import React, { Component, ReactNode } from 'react';
import { ErrorState } from './ErrorState';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
  isDowntime?: boolean;
}

interface State {
  hasError: boolean;
  error?: Error;
}

class ConvexErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    // Don't track errors during downtime
    if (this.props.isDowntime) {
      return;
    }

    // Analytics/Monitoring - using consolidated analytics hook would be better here
    // For now keeping gtag for error boundaries until we can inject the hook
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', 'convex_boundary_error', {
        error_message: error.message,
        error_stack: error.stack,
        component_stack: errorInfo.componentStack,
      });
    }

    // Send to error tracking service (e.g., Sentry)
    // if (window.Sentry) {
    //   window.Sentry.captureException(error, {
    //     contexts: { react: { componentStack: errorInfo.componentStack } }
    //   });
    // }
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: undefined });
  };

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }

      return (
        <div className="app-error-state-section">
          <ErrorState
            eyebrow="Data connection"
            title="Messages could not load"
            message="The realtime data layer had trouble rendering this view. Try again after a moment."
            primaryAction={{ label: 'Try again', onClick: this.handleRetry }}
            error={this.state.error}
          />
        </div>
      );
    }

    return this.props.children;
  }
}

export default ConvexErrorBoundary;
